import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
const AdmissionWithdrawals = () => {  
  useEffect(() => {
    document.title = 'Admission & Withdrawals - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Admission & Withdrawals</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <h3>Age Criteria for Admission</h3>
                    <div className="table-responsive maintable">
                    <table className="table">
                        <tbody>
                          <tr className="firsttr">
                            <td>LKG</td>
                            <td>Three and a half years on 1st of April of that academic year.</td>
                          </tr>
                          <tr className="seconedtr">
                            <td>UKG</td>
                            <td>Four and a half years on 1st of April of that academic year.</td>
                          </tr>
                          <tr className="firsttr">
                            <td>Class - I</td>
                            <td>Five and a half years on 1st of April of that academic year.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="clr"></div>
                    <ul className="mainlist">
                      <li>Admission to classes LKG&nbsp; are done on the basis of interviews to check the general awareness of the
                        child.</li>
                      <li>Students seeking admission to class 1st onwards will have to appear for entrance test based on the syllabus
                        of the previous class.</li>
                    </ul>
                    <h3>Documents to be Provided at the Time of Admission</h3>
                    <ul className="mainlist">
                      <li>Duly filled in application form.</li>
                      <li>Original School leaving/transfer certificate.</li>
                      <li>Attested photocopy of progress report of previous class passed.</li>
                      <li>Birth Certificate (Attested Photocopy)</li>
                      <li>One copy aadhar card</li>
                      <li>Two copies of latest passport size photograph of the child.</li>
                      <li>One copy family id</li>
                    </ul>
                    <h3>Procedure For Withdrawals</h3>
                    <p>Parents may withdraw their ward at the end of the school session by submitting a written application to the
                      Principal a month before the date of withdrawal. T.C. will be issued after all dues have been cleared. Failing
                      to give a month's notice would mean having to deposit a month's fees in lieu of the same.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default AdmissionWithdrawals;
